export const ConvertToSelectComponent = (
  items,
  refValue,
  refText,
  fixItems = null
) => {
  const valueConverted = [];

  if (items !== undefined) {
    items.map((item) => {
      valueConverted.push({
        value: item[refValue],
        text: item[refText],
      });
    });
  }

  if (fixItems) {
    fixItems.map((item) => {
      valueConverted.unshift({
        value: item.value,
        text: item.text,
      });
    });
  }

  return valueConverted;
};

export const ConvertEnumToSelectComponent = (enumitens, fixItems = null) => {
  const valueConverted = [];

  if (enumitens !== undefined) {
    enumitens.map((item) => {
      valueConverted.push({
        value: item,
        text: item,
      });
    });
  }

  if (fixItems) {
    fixItems.map((item) => {
      valueConverted.unshift({
        value: item.value,
        text: item.text,
      });
    });
  }

  return valueConverted;
};

export const ConvertTextValueToSelectComponent = (enumitens) => {
  const valueConverted = [];

  if (enumitens !== undefined) {
    enumitens.map((item) => {
      valueConverted.push({
        value: item.value,
        text: item.text,
      });
    });
  }
  return valueConverted;
};
